import { IBlankFormInternalCoBroke } from '@shared/data-access/interfaces/blank-form-internal-co-broke.interface';
import { IBlankFormExternalCoBroke } from '@shared/data-access/interfaces/blank-form-external-co-broke.interface';

export interface IBlankFormRelatedAgent {
  mains: IBlankFormInternalCoBroke[];
  leaders: IBlankFormInternalCoBroke[];
  internals: IBlankFormInternalCoBroke[];
  externals: IBlankFormExternalCoBroke[];
}
